export const concatClassNames = (...classes: any) => {
  return classes.filter(Boolean).join(" ");
};
